import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation AcceptUserInvitation($token: String!, $password: String, $name: String) {
    acceptUserInvitation(token: $token, password: $password, name: $name) {
      token
      customerId
    }
  }
`;

export const acceptUserInvitation = ({ token, password, name }) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { token, password, name },
  }).then(({ data }) => getSingleProp(data));
